export const apiDomain = process.env.EDUSYSTEM_DOMAIN
export const apiHost = process.env.EDUSYSTEM_API_HOST
export const apiProtocol = location.protocol.substring(0, location.protocol.length - 1) //process.env.EDUSYSTEM_API_PROTOCOL
export const environment = process.env.NODE_ENV
export const version = process.env.CLIENT_VERSION || 'development'
export const contentHost = process.env.EDUSYSTEM_CONTENT_HOST
export const staticAssetsDomain = process.env.STATIC_ASSETS_DOMAIN
export const converseDisabled = process.env.CONVERSE_DISABLED == 'true'

export const inViewer = navigator.userAgent.indexOf("EduSystemViewer") !== -1 || location.host.startsWith('localhost')
export const inWindowStore = navigator.userAgent.indexOf("EduSystemViewer-WindowsStore") !== -1

export function parentDomain (content, options = {}) {

  if (process.env.NODE_ENV == 'development') {
    if (options.devOverride) return options.devOverride
    else return content ? staticAssetsDomain.replace('static.', '') : apiDomain
  }

  const domains = location.hostname.split('.')
  return domains.length > 2
    ? domains.slice(1).join('.')
    : location.hostname
}

export function subdomainResource (subdomain, ...resource) {
  const domain = `${subdomain}.${parentDomain()}`
  return resource.length == 0 ? domain :`${domain}/${resource.join('/')}`
}

export function subdomainLink (subdomain, ...path) {
  return `//${subdomainResource(subdomain,...path)}`
}

export function pdfPreviewLink (subdomain, ...resource) {
  const parent = parentDomain(false, {devOverride: 'edufile.net'})
  const domain = `${subdomain}.${parent}`
  const pdfUrl = resource.length == 0 ? domain :`${domain}/${resource.join('/')}`
  return `//download.${parent}/pdfjs/web/viewer.html?file=//${pdfUrl}`
}

export function staticAssetLink (...path) {
  return `//static.${parentDomain(true)}/${path.join('/')}`
}

export function contentLink (passport, ...resource) {
  return `${apiProtocol}://${contentHost}.${parentDomain()}/${passport}/${resource.join('/')}`
}

export function viewerGuard ({target, href}) {
  return inViewer
    ? {target: '_self', href: `${href}__blank`}
    : {target, href}
}

export function parseOrderColumn(orderBy, defaultColumn){
  const order = orderBy ? (orderBy.startsWith('-') ? 'desc' : 'asc') : 'asc'
  const orderColumn = (order == 'asc' ? orderBy : orderBy.substring(1)) || defaultColumn
  return {order, orderColumn}
}